import * as React from "react";
function SvgChevronRightSm(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                d="M15.76 11.986a1.151 1.151 0 00-.39-.865L9.794 6.216a.923.923 0 00-1.22 1.386l4.877 4.29a.125.125 0 010 .188l-4.876 4.29a.924.924 0 101.22 1.386l5.573-4.904a1.153 1.153 0 00.392-.866z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgChevronRightSm);
export default ForwardRef;
